/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Case_Dropzone_Files_CountInputs */

const en_case_dropzone_files_count = /** @type {(inputs: Case_Dropzone_Files_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} files`)
};

const pt_br2_case_dropzone_files_count = /** @type {(inputs: Case_Dropzone_Files_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} arquivos`)
};

/**
* | output |
* | --- |
* | "{count} files" |
*
* @param {Case_Dropzone_Files_CountInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const case_dropzone_files_count = /** @type {((inputs: Case_Dropzone_Files_CountInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Case_Dropzone_Files_CountInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_case_dropzone_files_count(inputs)
	return pt_br2_case_dropzone_files_count(inputs)
});